import axios from "../axios";

export const getDwzsList = (data) => {
  return axios({
    url: '/dwzs/list',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 *  保存
 */
export const saveDwzs = (data) => {
  return axios({
    url: '/dwzs/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// batchDwzsInfo 批量设置
export const batchDwzsInfo = (data) => {
  return axios({
    url: '/dwzs/batchDwzsInfo',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// 删除证书信息

export const removeDwzs = (data) => {
  return axios({
    url: '/dwzs/removeDwzs',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

// exportDwzs 导出
export const exportDwzs = (data) => {
  return axios({
    url: '/dwzs/exportDwzs',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    responseType: 'blob',
    data
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, '单位证书.xlsx')
    }
  })
}
// downloadPdf 下载pdf

export const downloadPdf = (data) => {
  return axios({
    url: '/dwzs/downloadPdf',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    responseType: 'blob',
    data
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, `${data.dwmc}-登记证书.pdf`)
    }
  })
}
// findByInfo 查信息
export const findByInfo = (data) => {
  return axios({
    url: '/dwzs/findByInfo',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}
// getZsUrl 获取证书路径
export const getZsUrl = (data) => {
  return axios({
    url: '/dwzs/getZsUrl',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// verifyZsPwd
export const verifyZsPwd = (data) => {
  return axios({
    url: '/dwzs/verifyZsPwd',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
export const downloadZsZip = (data) => {
  return axios({
    url: '/dwzs/downloadZsZip',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    responseType: 'blob',
    data
  }).then(res => {
    console.log(res)
    if (res) {
      const name = '单位证书.zip'
      openDownloadDialog(res, name)
    }
  })
}

export const viewPdf = (data) => {
  return axios({
    url: '/dwzs/viewPdf',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
export const downloadZsWjZip = (data) => {
  return axios({
    url: '/dwzs/downloadZsWjZip',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    responseType: 'blob',
    data
  }).then(res => {
    console.log(res)
    if (res) {
      const type = data.type
      const name = '单位证书.zip'
      openDownloadDialog(res, name)
    }
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dwzs.js